
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import * as bs from "bootstrap";
import { AccountSummary } from "@/store/Account/AccountInterface";

export default defineComponent({
  name: "registration-link-card",
  data() {
    return {
      linkToCopy: "",
      copiedTooltip: {
        show() {
          return;
        },
        hide() {
          return;
        },
      },
    };
  },
  computed: {
    ...mapGetters("auth", ["getUsernamePK"]),
    ...mapGetters("account", ["getAccountSummary"]),
    accountSummary(): AccountSummary {
      return this.getAccountSummary;
    },
    linkBase(): string {
      const hrefArray = window.location.href.split("/");
      return hrefArray[0] + "//" + hrefArray[2] + "/registro/";
    },
    registrationLink(): string {
      return this.linkBase + this.getUsernamePK + "/";
    },
    binarySide(): string {
      return this.accountSummary?.binarySide
        ? this.accountSummary?.binarySide
        : "";
    },
    innerLegUnlocked(): boolean {
      // undefined = NOT PLACED = LOCKED. A member with no binaryTree node has no
      // power line to open. Defaulting to `true` here silently unlocked the inner
      // leg for every registered-not-yet-activated member (#559).
      if (this.accountSummary?.innerLegUnlocked == undefined) {
        return false;
      }
      return this.accountSummary?.innerLegUnlocked
        ? this.accountSummary?.innerLegUnlocked
        : false;
    },
  },
  mounted() {
    const txtReferralUrl = document.getElementById("referralUrl");
    this.copiedTooltip = new bs.Tooltip(txtReferralUrl);
  },
  methods: {
    copyToClipboard(side: string) {
      this.linkToCopy = this.registrationLink + side;
      const el = document.getElementById("referralUrl") as HTMLInputElement;
      el.value = this.linkToCopy;
      el.select();
      el.setSelectionRange(0, 99999);
      document.execCommand("copy");
      this.copiedTooltip.show();
      setTimeout(() => this.copiedTooltip.hide(), 2000);
    },
    sideVisible(btnSide: "right" | "left"): boolean {
      // THE RULE, stated once: while the inner leg is locked, only the POWER leg
      // may be recruited into. Written as two `binarySide == "left"/"right"`
      // branches, an UNKNOWN side (the computed collapses undefined to "")
      // matched neither and BOTH links were offered — the lock silently opened
      // in exactly the state where we know least. This fails CLOSED, and the
      // generic registration link above stays available either way.
      return this.innerLegUnlocked || btnSide === this.binarySide;
    },
    linkbuttonClass(btnSide: "right" | "left"): string {
      const classes = "btn btn-outline-secondary";
      if (!this.sideVisible(btnSide)) {
        return classes + " d-none";
      }
      // Sole survivor of the group: when the lock hides the other leg, this
      // button is alone in the .btn-group but Bootstrap still squares its inner
      // corners (it's still :first/:last-child). Mark it so all four corners
      // round — a lone link should read as a standalone button, not half a
      // group. When BOTH show, the join stays square (Bootstrap default).
      const other = btnSide === "left" ? "right" : "left";
      if (!this.sideVisible(other)) {
        return classes + " rlc-lone";
      }
      return classes;
    },
  },
});
